import { BillingContact } from '__generated__/atlas-types'

import { MAX_BILLING_CONTACTS } from './billingContactModal.constants'
import { EMAIL_VALIDATION_REGEX } from 'features/UserManagement/constants/constants'

export const newBillingContact = (): BillingContact => ({
  id: '',
  name: '',
  email: '',
})

export const areBillingContactsValid = (
  contacts: BillingContact[],
): boolean => {
  if (contacts.length < 1 || contacts.length > MAX_BILLING_CONTACTS) {
    // minimum one, max 3
    return false
  }

  return contacts.every(
    (contact, index) =>
      !!contact.name.trim() &&
      !!contact.email.trim() &&
      isValidEmail(contact.email) &&
      !isEmailRepeated(contacts, contact.email, index),
  )
}

export const isValidEmail = (email: string) =>
  EMAIL_VALIDATION_REGEX.test(email.trim())

export const isEmailRepeated = (
  contacts: BillingContact[],
  email: string,
  excludeIndex?: number,
) => {
  const normalizedEmail = email.trim().toLowerCase()
  return !normalizedEmail
    ? false
    : contacts.some(
        (c, index) =>
          index !== excludeIndex &&
          c.email.trim().toLowerCase() === normalizedEmail,
      )
}
